import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const useResetStateOnDismount = (type: string) => {
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch({ type })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useResetStateOnDismount
